import { Button, Loading, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useDeletePricingProfileMutation } from "@/redux/apis/config/trip/tripCost";
import { PricingProfile } from "@/redux/slices/trip/types";
import { addToast } from "@/utils";

interface DeletePricingProfileModalProps {
  open: boolean;
  onClose: () => void;
  selectedProfile?: PricingProfile;
}

export const DeletePricingProfileModal = ({ open, onClose, selectedProfile }: DeletePricingProfileModalProps) => {
  const [deletePricingProfile, { isLoading }] = useDeletePricingProfileMutation();

  const handleClose = () => {
    if (!isLoading) onClose();
  };

  const handleConfirmDelete = () => {
    if (selectedProfile) {
      deletePricingProfile({ id: selectedProfile?.id })
        .unwrap()
        .then(() => {
          addToast("success", "Successfully Deleted Pricing Profile");
          handleClose();
        })
        .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
    } else handleClose();
  };

  return (
    <Modal className="w-[85vw] md:w-[400px] lg:w-[400px]" open={open} onClose={handleClose}>
      <div className="relative flex flex-col">
        {isLoading && <Loading />}
        <Typography variant="title">Delete Pricing Profile</Typography>
        <Typography variant="paragraph" className="mt-2">
          Are you sure you want to delete this profile? Deleting it will permanently remove all associated data and you won&apos;t be able
          to recover it.
        </Typography>
        <div className="mt-8 flex w-full flex-row gap-3">
          <Button variant="secondary" size="lg" onClick={handleClose} className="flex-1">
            Cancel
          </Button>
          <Button variant="primary" size="lg" onClick={handleConfirmDelete} className="flex-1 border-none bg-danger hover:bg-danger-dark">
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
